import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { Button } from "@/components/ui/button";
import { FileText, Scale } from "lucide-react";

// Each template maps to a translation key whose value is the actual prompt
// that gets injected into the composer. Keys live under `chat.legal_templates`.
const TEMPLATES = [
  { id: "consulting", icon: FileText },
  { id: "nda", icon: FileText },
  { id: "privacy_gdpr", icon: Scale },
  { id: "ecommerce_tc", icon: FileText },
  { id: "diffida", icon: Scale },
  { id: "disdetta_locazione", icon: FileText },
  { id: "disciplinare", icon: Scale },
];

export function LegalTemplates({ onPick, disabled = false }) {
  const { t } = useI18n();
  return (
    <div
      className="mb-3 flex flex-wrap items-center gap-2"
      data-testid="legal-templates-bar"
    >
      <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#F4C955]">
        {t("chat.legal_templates_title")}
      </span>
      {TEMPLATES.map(({ id, icon: Icon }) => (
        <button
          key={id}
          type="button"
          onClick={() => onPick(t(`chat.legal_templates.${id}_prompt`))}
          disabled={disabled}
          className="inline-flex items-center gap-1.5 rounded-full border border-[#D4A937]/30 bg-[#D4A937]/5 px-3 py-1.5 text-[11px] font-medium text-[#F4C955] transition-colors hover:border-[#D4A937]/60 hover:bg-[#D4A937]/15 disabled:cursor-not-allowed disabled:opacity-50"
          data-testid={`legal-template-${id}`}
          title={t(`chat.legal_templates.${id}_label`)}
        >
          <Icon className="h-3 w-3" />
          {t(`chat.legal_templates.${id}_label`)}
        </button>
      ))}
    </div>
  );
}
